import React, { useState, useEffect } from "react";
import {
  Paper,
  Grid,
  Typography,
  Divider,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Button,
  TextField,
  IconButton,
  List,
  ListItem,
  ListItemText,
  CardContent,
  Card,
  Checkbox,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Radio,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import UpIcon from "@material-ui/icons/KeyboardArrowUp";
import DownIcon from "@material-ui/icons/KeyboardArrowDown";
import AddIcon from "@material-ui/icons/Add";
import { DropzoneArea } from "material-ui-dropzone";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../assets/jss/layouts/appStyle";
import { FormBuilderRepository } from "./FornBuilderRepository";
import { MunicipalitiesRepository } from "../configuration/municipalities/MunicipalitiesRepository";
import { SchoolsRepository } from "../configuration/schools/SchoolsRepository";
import { AuthService } from "../../auth/AuthService";
import { BorderAll } from "@material-ui/icons";

const useStyles = makeStyles(styles);

export default function FormBuilderModeler(props) {
  const classes = useStyles();

  const [customForm, setCustomForm] = React.useState({
    name: "",
    description: "",
    formDefinition: "",
  });
  const [json, setJson] = React.useState([
    {
      component: {
        type: "div",
        defaultValue: "div",
        variant: "div",
      },
    },
  ]);
  const [rerender, triggerRerender] = React.useState(false);
  const [propType, setPropType] = React.useState("");
  const [propVariant, setPropVariant] = React.useState();
  const [propName, setPropName] = React.useState();
  const [propRequired, setPropRequired] = React.useState(false);
  const [propMaxPoints, setPropMaxPoints] = React.useState();
  const [propDefaultPoints, setPropDefaultPoints] = React.useState();
  const [propUploadFilesLimit, setPropUploadFilesLimit] = React.useState(1);
  const [propUploadAcceptedFiles, setPropUploadAcceptedFiles] = React.useState([
    ".docx",
    ".pdf",
  ]);
  const [propUploadUserComment, setPropUploadUserComment] = React.useState();
  const [
    propUploadCommissionComment,
    setPropUploadCommissionComment,
  ] = React.useState();
  const [
    propUploadFileExtension,
    setPropUploadFileExtension,
  ] = React.useState();

  const [propDefaultValue, setPropDefaultValue] = React.useState();
  const [propDropdownKey, setPropDropdownKey] = React.useState();
  const [propDropdownValue, setPropDropdownValue] = React.useState();
  const [propDropdownOptions, setPropDropdownOptions] = React.useState([]);
  const [propDropdownType, setPropDropdownType] = React.useState(
    "municipalities"
  );

  const [formData, setFormData] = React.useState({
    // form1name: "yeees",
    // Name: "Sale",
    // Surname: "mangup",
    // Email: "angelovski.sashe1@gmail.com",
    // Telephone: "070323839",
    attachments: {},
  });
  const [files, setFiles] = React.useState([]);
  const [municipalities, setMunicipalities] = React.useState();
  const [schools, setSchools] = React.useState();

  React.useEffect(() => {
    if (props.id != undefined) {
      FormBuilderRepository.findById(props.id).then(
        (res) => {
          setCustomForm(res.data);
          setJson(JSON.parse(res.data.formDefinition));
        },
        (err) => {}
      );
    }
    MunicipalitiesRepository.fetchAllMunicipalities({
      page: 0,
      size: 100,
      orderBy: "name",
      orderDirection: "ASC",
    })
      .then((res) => {
        setMunicipalities(res.data.content);
      })
      .catch((err) => {});
  }, []);

  React.useEffect(() => {}, [rerender]);

  const createdFormActions = {
    handleSubmit() {},
    onFieldChange: function (name, event) {
      if (name.includes("Municipa")) {
        SchoolsRepository.fetchAllSchoolsByMunicipality({
          municipalityId: event.target.value,
        }).then(
          (res) => {
            setSchools(res.data);
          },
          (err) => {}
        );
      }
      var tmpFormData = formData;
      tmpFormData[name] = event.target.value;
      setFormData(tmpFormData);
      triggerRerender(!rerender);
    },
    onAttachmentChange: function (id, name, event) {
      var tmpFormData = formData;
      tmpFormData.attachments[id][name] = event.target.value;
      setFormData(tmpFormData);
      triggerRerender(!rerender);
    },
    uploadFile: function (maxPoints, defaultPoints, name, files) {
      var tmpFormData = formData;
      if (tmpFormData.attachments == undefined) {
        tmpFormData.attachments = {};
      }
      tmpFormData.attachments[name] = {
        userComment: "",
        commisionComment: "",
        points: defaultPoints,
        maxPoints: maxPoints,
      };
      setFormData(tmpFormData);
      setFiles(files);
    },
    hasRole: function (role) {
      var currentUser = JSON.parse(window.localStorage.getItem("currentUser"));
      for (var i = 0; i < currentUser.authorities.length; i++) {
        if (currentUser.authorities[i].authority == role) {
          return true;
        }
      }
    },
  };

  const handleChangeType = (event) => {
    setPropType(event.target.value);
  };

  const handleChangeDefaultValue = (event) => {
    setPropDefaultValue(event.target.value);
  };

  const handleChangeVariant = (event) => {
    setPropVariant(event.target.value);
  };
  const handleChangeName = (event) => {
    setPropName(event.target.value);
  };
  const handleChangeMaxPoints = (event) => {
    setPropMaxPoints(event.target.value);
  };
  const handleChangeDefaultPoints = (event) => {
    setPropDefaultPoints(event.target.value);
  };
  const handleChangeUploadFileLimit = (event) => {
    setPropUploadFilesLimit(event.target.value);
  };
  const handleChangeIsRequired = (event) => {
    setPropRequired(event.target.checked);
  };
  const handleChangeUploadUserComment = (event) => {
    setPropUploadUserComment(event.target.checked);
  };
  const handleChangeUploadCommisionComment = (event) => {
    setPropUploadCommissionComment(event.target.checked);
  };

  const handleChangeDropdownKey = (event) => {
    setPropDropdownKey(event.target.value);
  };
  const handleChangeDropdownValue = (event) => {
    setPropDropdownValue(event.target.value);
  };
  const handleChangeUploadFileExtension = (event) => {
    setPropUploadFileExtension(event.target.value);
  };

  const handleChangePropDropdownType = (event) => {
    setPropDropdownType(event.target.value);
  };

  const handleChangeFormName = (event) => {
    let data = customForm;
    data.name = event.target.value;
    setCustomForm(data);
    triggerRerender(!rerender);
  };

  const handleChangeFormDescription = (event) => {
    let data = customForm;
    data.description = event.target.value;
    setCustomForm(data);
    triggerRerender(!rerender);
  };

  const addOptionPair = () => {
    let options = propDropdownOptions;
    options.push({ [propDropdownKey]: propDropdownValue });
    setPropDropdownOptions(options);
    triggerRerender(!rerender);
  };

  const addAcceptedFile = () => {
    let options = propUploadAcceptedFiles;
    options.push(propUploadFileExtension);
    setPropUploadAcceptedFiles(options);
    triggerRerender(!rerender);
  };

  const removeAcceptedFile = (index) => {
    let options = propUploadAcceptedFiles;
    options.splice(index, 1);
    setPropUploadAcceptedFiles(options);
    triggerRerender(!rerender);
  };

  const deleteOptionPair = (index) => {
    let options = propDropdownOptions;
    options.splice(index, 1);
    setPropDropdownOptions(options);
    triggerRerender(!rerender);
  };

  const removeElement = (index) => {
    let json_data = json;
    json_data.splice(index, 1);
    setJson(json_data);
    triggerRerender(!rerender);
  };

  const moveElementUp = (index) => {
    let json_data = json;
    var b = json_data[index - 1];
    json_data[index - 1] = json_data[index];
    json_data[index] = b;
    setJson(json_data);
    triggerRerender(!rerender);
  };
  const moveElementDown = (index) => {
    let json_data = json;
    var b = json_data[index + 1];
    json_data[index + 1] = json_data[index];
    json_data[index] = b;
    setJson(json_data);
    triggerRerender(!rerender);
  };

  const addComponent = () => {
    let json_data = json;
    if (propType == "Typography") {
      json_data.push({
        component: {
          type: propType,
          name: propName,
          variant: propVariant,
        },
      });
    }
    if (propType == "TextField") {
      json_data.push({
        component: {
          type: propType,
          value: propDefaultValue,
          name: propName,
          required: propRequired,
        },
      });
    }
    if (propType == "Button") {
      json_data.push({
        component: {
          type: propType,
          onClick: "handleSubmit",
          name: propName,
        },
      });
    }
    if (propType == "FileUpload") {
      json_data.push({
        component: {
          type: propType,
          name: propName,
          filesLimit: propUploadFilesLimit,
          acceptedFiles: propUploadAcceptedFiles,
          maxPoints: propMaxPoints,
          defaultPoints: propDefaultPoints,
          required: propRequired,
          userComment: propUploadUserComment,
          commisionComment: propUploadCommissionComment,
        },
      });
    }
    if (propType == "DropdownList") {
      json_data.push({
        component: {
          type: propType,
          name: propName,
          optionsType: propDropdownType,
          options: propDropdownOptions,
        },
      });
    }

    setJson(json_data);
    triggerRerender(!rerender);
  };

  const saveForm = () => {
    let tmpCustomForm = customForm;
    tmpCustomForm.formDefinition = JSON.stringify(json);
    setCustomForm(tmpCustomForm);
    FormBuilderRepository.save(customForm).then(
      (res) => {
        setCustomForm(res.data);
      },
      (err) => {}
    );
  };

  return (
    <div className="componentContainer">
      <Grid container spacing={3}>
        <Grid item xs={8}>
          <Paper
            style={{
              textAlign: "center",
              alignItems: "center",
              flexDirection: "column",
              display: "flex",
              padding: "20px",
            }}
          >
            <Divider></Divider>
            {json.map((item, index) =>
              item?.component?.type == "Typography" ? (
                <Grid container key={index}>
                  <Grid item xs={10}>
                    <Typography variant={item.component.variant}>
                      {item.component.name}
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    {" "}
                    <IconButton onClick={() => removeElement(index)}>
                      <DeleteIcon />
                    </IconButton>
                    {index > 1 && (
                      <IconButton onClick={() => moveElementUp(index)}>
                        <UpIcon />
                      </IconButton>
                    )}
                    {index < json.length - 1 && (
                      <IconButton onClick={() => moveElementDown(index)}>
                        <DownIcon />
                      </IconButton>
                    )}
                  </Grid>
                </Grid>
              ) : item.component.type == "TextField" ? (
                <Grid container key={index}>
                  <Grid item xs={10}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      id={item.component.value}
                      label={item.component?.name}
                      multiline
                      rowsMax="4"
                      required={item.component.required}
                      onChange={createdFormActions.onFieldChange.bind(
                        this,
                        item.component.name
                      )}
                      value={
                        formData[item?.component?.name]
                          ? formData[item?.component?.name]
                          : item.component.value
                      }
                    />
                  </Grid>
                  <Grid item xs={2}>
                    {" "}
                    <IconButton onClick={() => removeElement(index)}>
                      <DeleteIcon />
                    </IconButton>
                    {index > 1 && (
                      <IconButton onClick={() => moveElementUp(index)}>
                        <UpIcon />
                      </IconButton>
                    )}
                    {index < json.length - 1 && (
                      <IconButton onClick={() => moveElementDown(index)}>
                        <DownIcon />
                      </IconButton>
                    )}
                  </Grid>
                </Grid>
              ) : item.component.type == "Button" ? (
                <Grid container key={index}>
                  <Grid item xs={10}>
                    <Button
                      key={index}
                      style={{ marginTop: "15px" }}
                      onClick={
                        item.component.onClick
                          ? "handleSubmit" && createdFormActions.handleSubmit
                          : createdFormActions.handleSubmit
                      }
                      variant="contained"
                      color="primary"
                      fullWidth
                    >
                      {item.component.name}
                    </Button>
                  </Grid>
                  <Grid item xs={2}>
                    {" "}
                    <IconButton onClick={() => removeElement(index)}>
                      <DeleteIcon />
                    </IconButton>
                    {index > 1 && (
                      <IconButton onClick={() => moveElementUp(index)}>
                        <UpIcon />
                      </IconButton>
                    )}
                    {index < json.length - 1 && (
                      <IconButton onClick={() => moveElementDown(index)}>
                        <DownIcon />
                      </IconButton>
                    )}
                  </Grid>
                </Grid>
              ) : item.component.type == "FileUpload" ? (
                <Grid container key={index}>
                  <Grid item xs={10}>
                    <Card
                      style={{
                        marginTop: "20px",
                        border: "1px solid #efefef",
                      }}
                    >
                      <DropzoneArea
                        dropzoneText={item.component.name}
                        acceptedFiles={propUploadAcceptedFiles}
                        filesLimit={parseInt(item.component.filesLimit)}
                        useChipsForPreview={true}
                        onChange={createdFormActions.uploadFile.bind(
                          this,
                          item.component.maxPoints,
                          item.component.defaultPoints,
                          item.component.name
                        )}
                      />
                      <CardContent>
                        {item.component.userComment && (
                          <TextField
                            fullWidth
                            multiline
                            disabled={
                              !createdFormActions.hasRole("ROLE_TEACHER")
                            }
                            onChange={
                              formData.attachments[item.component.name] &&
                              createdFormActions.onAttachmentChange.bind(
                                this,
                                item.component.name,
                                "userComment"
                              )
                            }
                            rows={4}
                            value={
                              formData.attachments[item.component.name]
                                ?.userComment
                                ? formData.attachments[item.component.name]
                                    ?.userComment
                                : ""
                            }
                            label="Коментар на апликант"
                          ></TextField>
                        )}
                        {item.component.commisionComment && (
                          <TextField
                            fullWidth
                            multiline
                            disabled={
                              !createdFormActions.hasRole("ROLE_COMMISION")
                            }
                            onChange={
                              formData.attachments[item.component.name] &&
                              createdFormActions.onAttachmentChange.bind(
                                this,
                                item.component.name,
                                "commisionComment"
                              )
                            }
                            value={
                              formData.attachments[item.component.name]
                                ?.commisionComment
                                ? formData.attachments[item.component.name]
                                    ?.commisionComment
                                : ""
                            }
                            rows={4}
                            label="Коментар на комисија"
                          ></TextField>
                        )}
                        <TextField
                          label="Бодови"
                          type="number"
                          disabled={
                            !createdFormActions.hasRole("ROLE_COMMISION")
                          }
                          onChange={
                            formData.attachments[item.component.name] &&
                            createdFormActions.onAttachmentChange.bind(
                              this,
                              item.component.name,
                              "points"
                            )
                          }
                          value={
                            formData.attachments[item.component.name]?.points
                              ? formData.attachments[item.component.name]
                                  ?.points
                              : item.component.defaultPoints
                          }
                          style={{ float: "right" }}
                        ></TextField>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={2}>
                    {" "}
                    <IconButton onClick={() => removeElement(index)}>
                      <DeleteIcon />
                    </IconButton>
                    {index > 1 && (
                      <IconButton onClick={() => moveElementUp(index)}>
                        <UpIcon />
                      </IconButton>
                    )}
                    {index < json.length - 1 && (
                      <IconButton onClick={() => moveElementDown(index)}>
                        <DownIcon />
                      </IconButton>
                    )}
                  </Grid>
                </Grid>
              ) : item.component.type == "DropdownList" ? (
                <Grid container key={index}>
                  <Grid item xs={10}>
                    <FormControl
                      variant="outlined"
                      fullWidth
                      style={{ marginTop: "15px" }}
                    >
                      <InputLabel id="demo-simple-select-label">
                        {item.component.name}
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={formData[item?.component?.name]}
                        onChange={createdFormActions.onFieldChange.bind(
                          this,
                          item.component.name
                        )}
                      >
                        {item.component.optionsType == "custom" &&
                          item.component.options?.map((element, index) => (
                            <MenuItem
                              key={index}
                              value={Object.keys(element)[0]}
                            >
                              {Object.values(element)[0]}
                            </MenuItem>
                          ))}
                        {item.component.optionsType == "municipalities" &&
                          municipalities?.map((element, index) => (
                            <MenuItem key={index} value={element.id}>
                              {element.name}
                            </MenuItem>
                          ))}
                        {item.component.optionsType == "schools" &&
                          schools?.map((element, index) => (
                            <MenuItem key={index} value={element.id}>
                              {element.name}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={2}>
                    {" "}
                    <IconButton onClick={() => removeElement(index)}>
                      <DeleteIcon />
                    </IconButton>
                    {index > 1 && (
                      <IconButton onClick={() => moveElementUp(index)}>
                        <UpIcon />
                      </IconButton>
                    )}
                    {index < json.length - 1 && (
                      <IconButton onClick={() => moveElementDown(index)}>
                        <DownIcon />
                      </IconButton>
                    )}
                  </Grid>
                </Grid>
              ) : item.component.type == "div" ? (
                <div key={index}></div>
              ) : (
                <React.Fragment></React.Fragment>
              )
            )}
          </Paper>
        </Grid>

        <Grid item xs={4}>
          <Paper
            style={{
              textAlign: "left",
              alignItems: "left",
              flexDirection: "column",
              display: "flex",
              padding: "20px",
            }}
          >
            <Typography variant="h5">Form Basic Info</Typography>
            <Divider></Divider>
            <TextField
              id="standard-multiline-flexible"
              label="Form Name"
              multiline
              rowsMax="4"
              value={customForm.name}
              onChange={handleChangeFormName}
            />
            <TextField
              id="standard-multiline-flexible"
              label="Name"
              multiline
              rowsMax="4"
              value={customForm.description}
              onChange={handleChangeFormDescription}
            />
            <br></br>
            <Typography variant="h5">Modeler</Typography>
            <Divider></Divider>
            <FormControl>
              <InputLabel id="simple-select-label">Property type</InputLabel>
              <Select
                style={{ minWidth: 120 }}
                labelId="simple-select-label"
                id="demo-simple-select"
                value={propType}
                onChange={handleChangeType}
              >
                <MenuItem value={"Typography"}>Typography</MenuItem>
                <MenuItem value={"TextField"}>Text Field</MenuItem>
                <MenuItem value={"Button"}>Button</MenuItem>
                <MenuItem value={"FileUpload"}>File Upload</MenuItem>
                <MenuItem value={"DropdownList"}>Dropdown List</MenuItem>
              </Select>
            </FormControl>

            <TextField
              id="standard-multiline-flexible"
              label="Name"
              multiline
              rowsMax="4"
              value={propName}
              onChange={handleChangeName}
            />

            {propType == "TextField" && (
              <div>
                <TextField
                  id="standard-multiline-flexible"
                  label="Value"
                  multiline
                  rowsMax="4"
                  value={propDefaultValue}
                  onChange={handleChangeDefaultValue}
                />
                <div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={propRequired}
                        onChange={handleChangeIsRequired}
                      />
                    }
                    label="Required"
                  />
                </div>
              </div>
            )}
            {propType == "Typography" && (
              <div>
                <TextField
                  id="standard-multiline-flexible"
                  label="Variant"
                  multiline
                  rowsMax="4"
                  value={propVariant}
                  onChange={handleChangeVariant}
                />
              </div>
            )}
            {propType == "DropdownList" && (
              <div>
                <div>
                  <br></br>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">Dropdown type</FormLabel>
                    <RadioGroup
                      aria-label="dropdownType"
                      name="dropdownType"
                      value={propDropdownType}
                      onChange={handleChangePropDropdownType}
                    >
                      <FormControlLabel
                        value="municipalities"
                        control={<Radio />}
                        label="Municipalities"
                      />
                      <FormControlLabel
                        value="schools"
                        control={<Radio />}
                        label="Schools"
                      />
                      <FormControlLabel
                        value="custom"
                        control={<Radio />}
                        label="Custom"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
                {propDropdownType == "custom" && (
                  <div>
                    <TextField
                      id="standard-multiline-flexible"
                      label="Key"
                      multiline
                      rowsMax="4"
                      value={propDropdownKey}
                      onChange={handleChangeDropdownKey}
                    />
                    <TextField
                      id="standard-multiline-flexible"
                      label="Value"
                      multiline
                      rowsMax="4"
                      value={propDropdownValue}
                      onChange={handleChangeDropdownValue}
                    />
                    <IconButton onClick={addOptionPair}>
                      <AddIcon />
                    </IconButton>

                    <div>
                      <Typography variant="h6">Options</Typography>
                      <List>
                        {propDropdownOptions.map((option, index) => (
                          <ListItem key={index}>
                            <ListItemText primary={Object.keys(option)[0]} />
                            <ListItemText primary={Object.values(option)[0]} />
                            <IconButton onClick={() => deleteOptionPair(index)}>
                              <DeleteIcon />
                            </IconButton>
                          </ListItem>
                        ))}
                      </List>
                    </div>
                  </div>
                )}
              </div>
            )}
            {propType == "FileUpload" && (
              <div>
                <TextField
                  id="maxPoints"
                  label="Max Points"
                  type="number"
                  value={propMaxPoints}
                  onChange={handleChangeMaxPoints}
                />
                <TextField
                  id="defaultPoints"
                  label="Default Points"
                  type="number"
                  value={propDefaultPoints}
                  onChange={handleChangeDefaultPoints}
                />
                <div>
                  <TextField
                    id="fileLimit"
                    label="Files Limit"
                    type="number"
                    value={propUploadFilesLimit}
                    onChange={handleChangeUploadFileLimit}
                  />
                </div>
                <div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={propRequired}
                        onChange={handleChangeIsRequired}
                      />
                    }
                    label="Required"
                  />
                </div>
                <div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        value="commentUser"
                        checked={propUploadUserComment}
                        onChange={handleChangeUploadUserComment}
                      />
                    }
                    label="Enable User Comment"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        value="commentInstitution"
                        checked={propUploadCommissionComment}
                        onChange={handleChangeUploadCommisionComment}
                      />
                    }
                    label="Enable Commision Comment"
                  />
                </div>
                <div>
                  <hr></hr>
                  <Typography variant="h6">Accepted Files</Typography>
                  <TextField
                    id="standard-multiline-flexible"
                    label="File extension"
                    multiline
                    rowsMax="4"
                    value={propUploadFileExtension}
                    onChange={handleChangeUploadFileExtension}
                  />
                  <IconButton onClick={addAcceptedFile}>
                    <AddIcon />
                  </IconButton>
                  <List>
                    {propUploadAcceptedFiles.map((option, index) => (
                      <ListItem key={index}>
                        <ListItemText primary={option} />
                        <IconButton onClick={() => removeAcceptedFile(index)}>
                          <DeleteIcon />
                        </IconButton>
                      </ListItem>
                    ))}
                  </List>
                </div>
              </div>
            )}
            <div
              style={{
                textAlign: "right",
                alignItems: "right",
                marginTop: "20px",
              }}
            >
              <Button
                size="small"
                variant="contained"
                color="primary"
                onClick={addComponent}
              >
                Add component
              </Button>
            </div>
            <div
              style={{
                textAlign: "right",
                alignItems: "right",
                marginTop: "20px",
              }}
            >
              <Button
                size="small"
                variant="contained"
                color="secondary"
                onClick={saveForm}
              >
                Save Form
              </Button>
            </div>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}
